<template>
  <div class="row">
    <DeviceList></DeviceList>
  </div>
</template>

<script>
import DeviceList from '@/components/blocks/DeviceList'
import { baseMixin } from '@/libs/app-mixin'

export default {
  name: 'Devices',
  mixins: [baseMixin],
  components: {
    DeviceList
  },
  data () {
    return {}
  },
  methods: {},
  mounted () {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Devices.vue